/**
 * Games Info Category Collection
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var core = require('core');
    var CategoryModel = require('portlets/games-info/categories/gamesinfo.category.model');
    var FavoritesCategoryModel = require('portlets/games-info/categories/gamesinfo.favorites.category.model');
    var RecentlyPlayedCategoryModel = require('portlets/games-info/categories/gamesinfo.recently-played.category.model');
    var BaseCollection = require('common/base.collection');

    module.exports = BaseCollection.extend({

        model: function(attrs, options) {
            if (attrs.enableDynamicCategory) {
                core.error('"enableDynamicCategory" is not supported');
                return new CategoryModel(attrs, options);
            }
            if (attrs.name === 'favorites') {
                return new FavoritesCategoryModel(attrs, options);
            }
            if (attrs.name === 'recentlyplayed') {
                return new RecentlyPlayedCategoryModel(attrs, options);
            }
            return new CategoryModel(attrs, options);
        },

        getActive: function() {
            return this.findWhere({active: true});
        },

        getActiveName: function() {
            var activeCategory = this.getActive();
            return activeCategory && activeCategory.get('name');
        },

        setActive: function(categoryName) {
            this.forEach(function(model) {
                model.set('active', false, {silent: true});
            });
            var category = this.findWhere({name: categoryName}) || this.getDefaultCategory();
            if (category) {
                category.set('active', true);
            }
        },

        getDefaultCategory: function() {
            return this.findWhere({dynamic: false}) || this.first();
        },

        getGameCodes: function() {
            return _.uniq(this.reduce(function(games, category) {
                return games.concat(category.get('games'));
            }, []));
        },

        getGameConfigurations: function() {
            var gameCodes = this.getGameCodes();

            return _.toArray(Playtech.Variables.gamesConfiguration)
                .filter(function(game) {
                    return gameCodes.includes(game.gameCode);
                });
        }
    });
});
